import CrmFollowUpRulesAPI from '../../api/saas/crmFollowUpRules';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getRules($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getRulesByStage: $state => stageId => {
    return $state.records.filter(
      rule => rule.saas_pipeline_stage_id === stageId
    );
  },
};

const actions = {
  async get({ commit }, params = {}) {
    commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isFetching: true });
    try {
      const response = await CrmFollowUpRulesAPI.get(params);
      commit('SET_CRM_FOLLOW_UP_RULES', response.data || []);
      return response.data;
    } finally {
      commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isFetching: false });
    }
  },
  async create({ commit }, data) {
    commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isCreating: true });
    try {
      const response = await CrmFollowUpRulesAPI.create(data);
      commit('ADD_CRM_FOLLOW_UP_RULE', response.data);
      return response.data;
    } finally {
      commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isCreating: false });
    }
  },
  async update({ commit }, { id, ...data }) {
    commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isUpdating: true });
    try {
      const response = await CrmFollowUpRulesAPI.update(id, data);
      commit('UPDATE_CRM_FOLLOW_UP_RULE', response.data);
      return response.data;
    } finally {
      commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isDeleting: true });
    try {
      await CrmFollowUpRulesAPI.delete(id);
      commit('DELETE_CRM_FOLLOW_UP_RULE', id);
    } finally {
      commit('SET_CRM_FOLLOW_UP_RULES_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_CRM_FOLLOW_UP_RULES_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_CRM_FOLLOW_UP_RULES($state, data) {
    $state.records = data;
  },
  ADD_CRM_FOLLOW_UP_RULE($state, data) {
    const exists = $state.records.some(rule => rule.id === data.id);
    if (!exists) $state.records.push(data);
  },
  UPDATE_CRM_FOLLOW_UP_RULE($state, data) {
    const idx = $state.records.findIndex(rule => rule.id === data.id);
    if (idx === -1) {
      $state.records.push(data);
    } else {
      $state.records.splice(idx, 1, data);
    }
  },
  DELETE_CRM_FOLLOW_UP_RULE($state, id) {
    $state.records = $state.records.filter(rule => rule.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
